// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_tl-5";
export var filledCircle = "_tl-4";
export var historyEntry = "_tl-3";
export var messageSideLeft = "_tl-1";
export var messageSideRight = "_tl-2";
export var orderTrackingCarouselWrapper = "_tl-6";
export var orderTrackingInfoContainer = "_tl-0";